module.exports = __webpack_public_path__ + "img/ico_biaoqianbaoshi.b230a238.png";